/**
 * Title 26 / IRS mandatory calendar rows are tagged with itemCode USA_HEALTHCARE_TITLE26_*
 * when injected from the aggregator (see unicomply-rules facility_compliance_service).
 *
 * Product rule: rows matching this predicate must never appear in the Facility Compliance Calendar
 * accordion — only in Tax Compliance Calendar when `show_tax_compliance_calendar` is true
 * (see Penalty.tsx and FacilityCompliance.tsx).
 */
export function isTaxComplianceCalendarItem(item: unknown): boolean {
  if (!item || typeof item !== "object") return false;
  const o = item as Record<string, unknown>;
  const code = o.itemCode ?? o.item_code;
  if (typeof code !== "string") return false;
  return code.includes("TITLE26");
}
